module.exports = __webpack_public_path__ + "static/media/react.4ade5cac.png";